import { __extends } from "tslib";
import { Simulate } from 'react-dom/test-utils';
import { SuperLegacyBaseDriver } from '@wix/answers-lib';
var SuperLegacySelectDriver = /** @class */ (function (_super) {
    __extends(SuperLegacySelectDriver, _super);
    function SuperLegacySelectDriver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuperLegacySelectDriver.prototype.openSelection = function () {
        Simulate.focus(this.find('.Select-input input'));
    };
    SuperLegacySelectDriver.prototype.selectAtIndex = function (index) {
        this.openSelection();
        var elem = this.findAll('.Select-option')[index];
        Simulate.mouseDown(elem);
    };
    SuperLegacySelectDriver.prototype.getSelectionTitles = function () {
        this.openSelection();
        return this.getAllTextBySelector('.Select-option');
    };
    SuperLegacySelectDriver.prototype.selectByOptionClassName = function (className) {
        this.openSelection();
        var elem = this.find(".Select-option." + className);
        Simulate.mouseDown(elem);
    };
    return SuperLegacySelectDriver;
}(SuperLegacyBaseDriver));
export { SuperLegacySelectDriver };
//# sourceMappingURL=select.super-legacy-driver.js.map